export default "__VITE_ASSET__BrayMBZk__"